import { storage } from '../../../js/utils/storage.js';
import { perkTierForUser } from '../../../js/utils/membershipUsage.js';
import { filterOutfitIdsForSfw } from '../../../js/utils/nsfwTags.js';

export const hasPaidMembership = (userData) => {
  const membershipTier = perkTierForUser(userData);
  return membershipTier && membershipTier !== 'free';
};

const isOutfitAvailable = (outfitId, isPaid) => {
  const parsedId = typeof outfitId === 'number' ? outfitId : parseInt(String(outfitId), 10);
  if (parsedId === 0 || parsedId === 1) return true;
  return isPaid;
};

export const isOutfitLockedByMembership = (outfitId) => {
  const parsedId = typeof outfitId === 'number' ? outfitId : parseInt(String(outfitId), 10);
  if (!Number.isFinite(parsedId)) return false;
  return !isOutfitAvailable(parsedId, hasPaidMembership(storage.get('userData') || {}));
};

export const filterOutfitsByMembership = (outfits) => {
  const isPaid = hasPaidMembership(storage.get('userData'));
  const owned = outfits.filter(outfitId => isOutfitAvailable(outfitId, isPaid));
  const unowned = outfits.filter(outfitId => !isOutfitAvailable(outfitId, isPaid));
  return { owned, unowned };
};

export const classifyScenarioOutfits = (outfits, characterOutfits) => {
  const isPaid = hasPaidMembership(storage.get('userData'));

  const owned = [];
  const unownedByMembership = [];
  const unownedByCharacter = [];

  for (const outfitId of filterOutfitIdsForSfw(outfits) || []) {
    const parsedId = parseInt(String(outfitId), 10);
    const characterHasIt = !characterOutfits || characterOutfits.has(parsedId);

    if (!characterHasIt) {
      unownedByCharacter.push(outfitId);
    } else if (!isOutfitAvailable(parsedId, isPaid)) {
      unownedByMembership.push(outfitId);
    } else {
      owned.push(outfitId);
    }
  }

  return { owned, unownedByMembership, unownedByCharacter };
};

const CLASSIFIED_GROUPS = [
  ['owned', true, null],
  ['unownedByMembership', false, 'membership'],
  ['unownedByCharacter', false, 'character']
];

export const appendClassifiedOutfitElements = async (traitsList, outfitData, { maxOutfits, createElement }) => {
  let renderedCount = 0;
  for (const [key, isOwned, lockReason] of CLASSIFIED_GROUPS) {
    for (const outfitId of outfitData[key] || []) {
      if (renderedCount >= maxOutfits) {
        return allOutfitIds(outfitData);
      }
      traitsList.appendChild(await createElement(outfitId, isOwned, lockReason));
      renderedCount++;
    }
  }
  return allOutfitIds(outfitData);
};

const allOutfitIds = (outfitData) => [
  ...(outfitData.owned || []),
  ...(outfitData.unownedByMembership || []),
  ...(outfitData.unownedByCharacter || [])
];

export const setActiveOutfitOnList = (traitsList, allOutfits, selectedOutfitId) => {
  if (!traitsList) return selectedOutfitId;
  const selected = allOutfits.some((id) => String(id) === String(selectedOutfitId))
    ? String(selectedOutfitId)
    : (allOutfits[0] != null ? String(allOutfits[0]) : '0');

  traitsList.querySelectorAll('.trait-tag').forEach((el) => el.classList.remove('active'));
  const activeElement = traitsList.querySelector(`[data-outfit-id="${selected}"]`);
  if (activeElement) activeElement.classList.add('active');
  return selected;
};
